import Const from 'constants';

const StackQuarterbackWithPassReceivers = {
    setStackQuarterbackWithPassReceiversFromStorage(value) {
        return (dispatch) => {
            dispatch(this.stackQuarterbackWithPassReceivers(value, {saveToStorage: false}));
        };
    },

    stackQuarterbackWithPassReceivers(value, options = {}) {
        return (dispatch) => {
            const {saveToStorage = true} = options;

            dispatch({
                type: Const.STACK_QUARTERBACK_WITH_PASS_CATCHERS,
                stackQuarterbackWithPassReceivers: Boolean(value),
            });

            saveToStorage && dispatch(
                this.saveDataToStorage('stackQuarterbackWithPassReceivers', function (state) {
                    const {filters} = state.lineupsData;

                    return filters.stackQuarterbackWithPassReceivers;
                }),
            );
        };
    },
};

export default StackQuarterbackWithPassReceivers;
